// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3fBin","rootSmall":"AddTileButton_rootSmall__3s1IS"};